<template>
  <div class="store-selector">
    <b-loading :active="loading"></b-loading>
    <h2 class="store-selector__title">
      店家名單
      <small>沒有看到喜歡的店家？前往 <router-link to="/store/create/">新增店家</router-link></small>
    </h2>
    <div class="columns store-selector__content">
      <div class="column">
        <div class="store-selector__box p-0" v-if="menus.length">
          <b-table
            :data="menus"
            :mobile-cards="false"
            :row-class="() => 'store-list__row'"
            class="store-list"
            scrollable
            @click="onSelect"
          >
            <b-table-column :th-attrs="columnThAttrs" field="id" label="No." v-slot="props">
              {{ props.index + 1 }}.
            </b-table-column>
            <b-table-column
              :th-attrs="columnThAttrs"
              field="storeInfo.store_detail.name"
              label="店家名稱"
              cell-class="store-list__name-column"
              sortable
              v-slot="props">
              <span class="store-list__name-column--icon">
                選
              </span>
              <span class="store-list__name-column--content">
                {{ props.row.storeInfo.store_detail.name }}
              </span>
            </b-table-column>
            <b-table-column
              :th-attrs="columnThAttrs"
              field="name"
              label="菜單名稱"
              sortable
              v-slot="props"
            >
              {{ props.row.name }}
            </b-table-column>
            <b-table-column
              :th-attrs="columnThAttrs"
              field="menuItems"
              label="內容(菜單前三項品項)"
              v-slot="props"
            >
              {{ getMenuItems(props.row) }}
            </b-table-column>
            <b-table-column
              :th-attrs="columnThAttrs"
              field="tags"
              label="標籤"
              v-slot="props"
            >
              <b-tag
                v-for="(tag, index) in props.row.storeInfo.store_tags"
                class="mx-1"
                type="is-light"
                :key="`store-${props.row.id}-tag-${index}`"
                rounded>
                {{ tag.name }}
              </b-tag>
            </b-table-column>
            <b-table-column
              :th-attrs="columnThAttrs"
              field="holiday"
              label="公休日"
              v-slot="props"
            >
              {{ transformClosedDays(props.row.storeInfo.store_close_days) }}
            </b-table-column>
            <b-table-column
              :th-attrs="columnThAttrs"
              field="updated_at"
              label="最後更新日期"
              sortable
              v-slot="props"
            >
              {{ humanizeDate(props.row.updated_at) }}
            </b-table-column>
          </b-table>
        </div>
        <div
          v-else
          class="px-4 py-2"
        >
          <template v-if="!loading">
            尚未建立名單喔，立刻
            <router-link to="/store/create">
              新增店家及菜單
            </router-link>
            吧！
            <div class="mt-4">
              <router-link
                to="/store/create"
                class="button is-primary">
                <span class="icon-plus has-text-white mr-2" />
                新增店家
              </router-link>
            </div>
            <section class="
              is-flex
              is-align-items-center
              is-justify-content-center
              store-table__empty--image
            ">
              <img
                alt="Empty Store List"
                src="@/assets/images/empty-store-list-image.svg"
                width="50%"
              />
            </section>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StoreSelector from './StoreSelector';

export default StoreSelector;
</script>

<style lang="scss" scoped>
@import "StoreSelector";
</style>
